import { render, staticRenderFns } from "./AlgorithmCollectionSelection.vue?vue&type=template&id=5bbb94ba&scoped=true&lang=html&"
import script from "./AlgorithmCollectionSelection.vue?vue&type=script&lang=js&"
export * from "./AlgorithmCollectionSelection.vue?vue&type=script&lang=js&"
import style0 from "./AlgorithmCollectionSelection.vue?vue&type=style&index=0&id=5bbb94ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb94ba",
  null
  
)

export default component.exports